export const Mandiri = require('./mandiri.png')
export const BCA = require('./bca.png')
export const BNI = require('./bni.png')
export const BRI = require('./bri.png')
export const Danamon = require('./danamon.png')
export const Permata = require('./permata.png')
export const CIMB = require('./cimb.png')
export const BII = require('./bii.png')
export const Hana = require('./hana.png')
export const Sampoerna = require('./sampoerna.png')
export const BSI = require('./bsi.png')
export const BNC = require('./bnc.png')
export const BJB = require('./bjb.png')
export const Sinarmas = require('./sinarmas.png')
export const BTPN = require('./btpn.png')
export const DKI = require('./dki.png')
export const Gopay = require('./gopay.png')
export const Visa = require('./visa.png')
export const Ovo = require('./ovo.png')
export const Dana = require('./dana.png')
export const ShopeePay = require('./shopeepay.png')
export const Jenius = require('./jenius.png')
export const Kredivo = require('./kredivo.png')
export const Qris = require('./qris.png')
export const Doku = require('./doku.png')
export const Indodana = require('./indodana.png')
export const LinkAja = require('./linkaja.png')
export const AtmBersama = require('./atm.png')
export const Alfamart = require('./alfamart.png')
export const Alfamidi = require('./alfamidi.png')
export const Alfaexpress = require('./alfaexpress.png')
export const DanDan = require('./dandan.png')
export const Indomaret = require('./indomaret.png')
export const CashPayment = require('./cashpayment.png')
export const Paypal = require('./paypal.png')
export const Wise = require('./wise.png')
export const Stripe = require('./stripe.png')
export const Maybank = require('./maybank.png')
export const BankChina = require('./bankchina.png')
export const UnionPay = require('./unionpay.png')
export const mandiriVA = require('./mandiriva.png')
export const bcaVA = require('./bcava.png')
export const bniVA = require('./bniva.png')
export const Mastercard = require('./mastercard.png')